export function getApiDetail(error) {
  return error?.response?.data?.detail;
}

export function isTenantSetupIncompleteDetail(detail) {
  return !!detail && typeof detail === 'object' && detail.error === 'tenant_setup_incomplete';
}

export function extractTenantSetupGate(error) {
  const detail = getApiDetail(error);
  if (!isTenantSetupIncompleteDetail(detail)) return null;
  return {
    capability: detail.capability || 'tenant_setup',
    action: detail.action || 'this action',
    message: detail.message || 'Finish Workspace Settings before continuing.',
    missingFields: Array.isArray(detail.missing_fields) ? detail.missing_fields : [],
    settingsPath: detail.settings_path || '/portal/settings',
  };
}

export function tenantSetupGateToastMessage(gate) {
  if (!gate) return 'Finish Workspace Settings before continuing.';
  const count = gate.missingFields.length;
  return count > 0
    ? `${gate.message} ${count} setup item${count === 1 ? '' : 's'} missing.`
    : gate.message;
}
